import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import ActiveLink from "@/components/ActiveLink";
import DropdownMenu from "@/components/DropdownMenu";
import { SearchForm, SearchFormSp } from "@/components/Form/index";
import LogoutModal from "@/components/LogoutModal";
import { useAuthUserQuery, useModal } from "@/hooks";
import { profileIconImages } from "@/lib/constants";
import routes from "@/lib/routes";
import dropDownStyles from "@/styles/DropdownMenu.module.scss";
import styles from "@/styles/Header.module.scss";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";
var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};
IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
import Notice from "./Notice";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AuthorizedNavigation(_ref) {
  var _loggedIn$currentProf, _loggedIn$currentProf2;
  let {
    loggedIn
  } = _ref;
  const {
    showModal
  } = useModal();
  const showLogoutModal = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(LogoutModal, {}), {
      closeButton: false,
      style: "logout"
    });
  }, []);
  if (!loggedIn) return null;
  if (!(loggedIn !== null && loggedIn !== void 0 && loggedIn.currentProfile)) return null;
  const ownerProfile = loggedIn === null || loggedIn === void 0 || (_loggedIn$currentProf = loggedIn.currentProfile) === null || _loggedIn$currentProf === void 0 ? void 0 : _loggedIn$currentProf.ownerProfile;
  const iconId = (loggedIn === null || loggedIn === void 0 || (_loggedIn$currentProf2 = loggedIn.currentProfile) === null || _loggedIn$currentProf2 === void 0 ? void 0 : _loggedIn$currentProf2.icon) || 1;
  return /*#__PURE__*/_jsx("div", {
    className: `${styles.navElement} ${styles.user}`,
    children: /*#__PURE__*/_jsx("ul", {
      className: styles.user,
      children: /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsxs(DropdownMenu, {
          right: true,
          button: /*#__PURE__*/_jsxs("a", {
            className: styles.userMenuOpenBtn,
            role: "button",
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.profileImage,
              children: !!profileIconImages[iconId] && /*#__PURE__*/_jsx(Image, {
                src: profileIconImages[iconId],
                width: 28,
                height: 28
              })
            }), /*#__PURE__*/_jsxs("span", {
              className: styles.profileName,
              children: [loggedIn.currentProfile.displayName, /*#__PURE__*/_jsx("span", {
                className: styles.iconDropdown,
                children: /*#__PURE__*/_jsx(IconArrow, {})
              })]
            })]
          }),
          scopedClass: dropDownStyles.forHeaderMenu,
          children: [/*#__PURE__*/_jsx("div", {
            className: `${dropDownStyles.innerSection} ${styles.dropDownProfileName}`,
            children: /*#__PURE__*/_jsx("div", {
              children: loggedIn.currentProfile.displayName
            })
          }), /*#__PURE__*/_jsx("div", {
            className: dropDownStyles.innerSection,
            children: /*#__PURE__*/_jsxs("ul", {
              className: dropDownStyles.lists,
              children: [ownerProfile && /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx(Link, {
                  href: routes.account,
                  className: dropDownStyles.link,
                  children: "\u30A2\u30AB\u30A6\u30F3\u30C8"
                })
              }), /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx(Link, {
                  href: routes.profileSwitch(),
                  className: dropDownStyles.link,
                  children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u5207\u308A\u66FF\u3048"
                })
              })]
            })
          }), /*#__PURE__*/_jsx("div", {
            className: dropDownStyles.innerSection,
            children: /*#__PURE__*/_jsx("ul", {
              className: dropDownStyles.lists,
              children: /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/static/feature/constant/guide",
                  className: dropDownStyles.link,
                  children: "\u3054\u5229\u7528\u30AC\u30A4\u30C9"
                })
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: dropDownStyles.innerSection,
            children: /*#__PURE__*/_jsx("ul", {
              className: dropDownStyles.lists,
              children: /*#__PURE__*/_jsx("li", {
                className: dropDownStyles.list,
                children: /*#__PURE__*/_jsx("a", {
                  className: dropDownStyles.link,
                  onClick: showLogoutModal,
                  children: "\u30ED\u30B0\u30A2\u30A6\u30C8"
                })
              })
            })
          })]
        })
      })
    })
  });
}
function NotAuthorizedNavigation(_ref2) {
  let {
    loggedIn
  } = _ref2;
  if (loggedIn) return null;
  return /*#__PURE__*/_jsx("div", {
    className: `${styles.navElement} ${styles.anonymous}`,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.btnArea,
      children: [/*#__PURE__*/_jsx(ActiveLink, {
        href: routes.login,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.secondaryNavigationContLink,
          children: /*#__PURE__*/_jsx("span", {
            children: "\u30ED\u30B0\u30A4\u30F3"
          })
        })
      }), /*#__PURE__*/_jsx(ActiveLink, {
        href: routes.signUp,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.secondaryNavigationContLink,
          children: /*#__PURE__*/_jsx("span", {
            children: "\u4F1A\u54E1\u767B\u9332"
          })
        })
      })]
    })
  });
}
export default function SecondaryNavigation() {
  const router = useRouter();
  const {
    loading,
    data
  } = useAuthUserQuery({
    fetchPolicy: "cache-first"
  });
  const loggedIn = !loading && (data === null || data === void 0 ? void 0 : data.user);
  const handleSubmit = useCallback(data => {
    router.push(routes.search(data.search));
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.secondaryNavigation,
    children: [/*#__PURE__*/_jsx(SearchForm, {
      onSubmit: handleSubmit
    }), /*#__PURE__*/_jsx(SearchFormSp, {
      onSubmit: handleSubmit
    }), /*#__PURE__*/_jsx(Notice, {}), /*#__PURE__*/_jsx(NotAuthorizedNavigation, {
      loggedIn: loggedIn
    }), /*#__PURE__*/_jsx(AuthorizedNavigation, {
      loggedIn: loggedIn
    })]
  });
}